import { Modal, Button } from '@/components';

interface ConfirmationProps {
  visible: boolean;
  title?: string;
  message: string;
  errorMessage?: string;
  onConfirm: () => void;
  confirmLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  cancelLabel?: string;
  extraButtons?: Array<{
    label: string;
    className?: string;
    onClick: () => void;
  }>;
}

export const Confirmation = ({
  visible,
  title,
  message,
  errorMessage,
  onConfirm,
  confirmLabel = 'Yes',
  loading = false,
  onCancel,
  cancelLabel = 'Cancel',
  extraButtons = [],
}: ConfirmationProps) => (
  <Modal
    className="flex flex-col justify-between"
    closeButtonClassName="absolute top-0 right-0 p-3 text-pt-primary-child hover:text-pt-secondary"
    visible={visible}
    onClose={onCancel}
  >
    {title && (
      <header className="bg-pt-primary text-pt-primary-child px-6 py-3 rounded-t-lg">
        <h2 className="font-black text-2xl">{title}</h2>
      </header>
    )}

    <div className="p-6">
      <p>{message}</p>

      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </div>

    <footer className="flex gap-3 justify-end bg-pt-secondary text-pt-secondary-child px-6 py-3 rounded-b-lg">
      <Button style="secondary" size="sm" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button style="primary" size="sm" onClick={onConfirm} loading={loading}>
        {confirmLabel}
      </Button>
      {extraButtons?.map(({ label, className, onClick }, index) => (
        <Button
          key={index}
          className={className}
          style="primary"
          size="sm"
          onClick={onClick}
        >
          {label}
        </Button>
      ))}
    </footer>
  </Modal>
);
